import * as tmaSdk from "@tma.js/sdk";
import loadConfig from "@tonWalletConfig/config";
import vailcode from "@utils/errcode";
import { Address, toNano } from "@ton/core";
import WebApp from "@twa-dev/sdk";
const initData = WebApp.initData;
import router from "@/router"; // 引入 router 实例
let spinsRecoveryTimer = null;
export default {
  namespaced: true,
  state: {
    isLogin: false,
    token: null,
    userInfo: {},
    taskCount: null,
    settingInfo: null,
    spinsPriceList: null,

    paymentStarsInfo: {
      timer: null,
      isLoading: false,
    },
    userCardInfo: null,

  },
  mutations: {
    setIsLogin: (state, payload) => (state.isLogin = payload),
    setToken: (state, payload) => (state.token = payload),
    setTaskCount: (state, payload) => (state.taskCount = payload),
    setUserInfo: (state, payload) => {
      for (const key in payload) {
        _v.$set(state.userInfo, key, payload[key]);
      }
    },
    setSettingInfo: (state, payload) => (state.settingInfo = payload),
    setUserCardInfo: (state, payload) => (state.userCardInfo = payload),
  },
  actions: {
    //初始化
    initProcess: async ({ state, dispatch, commit }) => {
      await dispatch("getSystemInit");
      await dispatch("setInitStatistics");
      await dispatch("getLoginInfo");
      await dispatch("getUserRights");
      // dispatch("setInApp");
      // await dispatch("onlineRefresh");
    },
    //获取登录信息
    getLoginInfo: ({ state, commit, dispatch, rootState }) => {
      return new Promise(async (resolve, reject) => {
        let inviteCode = "";
        let groupId = "";
        let start_param = _v.WebApp.initDataUnsafe.start_param;
        if (start_param && start_param.indexOf("ref_") !== -1) {
          let tstart_param = start_param.split("-");
          console.log("tstart_param", tstart_param);
          tstart_param.map((item) => {
            if (item.indexOf("ref_") !== -1) {
              inviteCode = item.replace("ref_", "");
            }
          });
        }
        const res = await _v.$http.post("auth/login", { initData, inviteCode, groupId });
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              reject();
              commit("setIsLogin", false);
              return;
            }
            commit("setToken", data.token);
            // data.userInfo.coin = 0
            commit("setUserInfo", data.userInfo);
            commit("setTaskCount", data.task_count || 0);
            resolve(data);
          },
          (err) => {
            console.log(`%c getLoginInfo err: ${err}`, "color: red; font-size: 14px;");
            commit("setIsLogin", false);
            reject(null);
          }
        );
      });
    },
    //获取mini-app初始化信息
    getSystemInit: ({ state, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/system/init", {});
        vailcode(
          res,
          () => {
            commit("setSettingInfo", res.data);
            resolve(1);
          },
          () => {
            reject(null);
            commit("setIsLogin", false);
          }
        );
      });
    },
    //进入app
    setInApp: async ({ state, dispatch }) => {
      const in_app = state.userInfo.in_app;
      !in_app && router.push("/adm");
    },
    getInapp: async ({ state, commit, dispatch }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/user/inapp", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            commit("setUserInfo", data);
            resolve(1);
            !data.in_app && router.push("/adm");
          },
          () => {
            reject(null);
            commit("setIsLogin", false);
          }
        );
      });
    },
    //设置mini-app
    setInitStatistics: ({ state, dispatch, commit }) => {
      return new Promise(async (resolve, reject) => {
        if (!state.settingInfo) {
          commit("setIsLogin", false);
        }
        console.log("state.settingInfo", state.settingInfo);
        const setMiniAppHead = () => {
          document.title = state.settingInfo.coin;
          state.settingInfo.statistics.map((item) => {
            if (item.type == "plausible" && item.value) {
              const pScript = document.createElement("script");
              pScript.src = `https://plausible.io/js/script.js`;
              pScript.defer = true;
              pScript.setAttribute("data-domain", item.value);
              document.head.appendChild(pScript);
              resolve(1);
            }
            if (item.type == "google" && item.value) {
              const gaScript = document.createElement("script");
              gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${item.value}`;
              gaScript.async = true;
              gaScript.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                  dataLayer.push(arguments);
                  resolve(1);
                }
                gtag("js", new Date());
                gtag("config", item.value);
              };

              document.head.appendChild(gaScript);
            }
          });
        };
        const setMiniAppLink = () => {
          if ((_v.WebApp.initDataUnsafe.start_param || "").indexOf("page_") !== -1) {
            let tstart_param = (_v.WebApp.initDataUnsafe.start_param || "").split("-");
            let page = "";
            let id = "";
            let inviteCode = "";
            tstart_param.map((item) => {
              if (item.indexOf("page_") !== -1) {
                page = item.replace("page_", "");
              }
              if (item.indexOf("id_") !== -1) {
                id = item.replace("id_", "");
              }
              if (item.indexOf("ref_") !== -1) {
                inviteCode = item.replace("ref_", "");
              }
            });
            if (page) {
              let url = `/${page}${id ? `?id=${id}` : ""}`;
              if (inviteCode) {
                if (url.indexOf("?") !== -1) {
                  url += "&invitecode=" + inviteCode;
                } else {
                  url += "?invitecode=" + inviteCode;
                }
              }
              router.push(url);
            }
          }
        };
        _v.WebApp.isClosingConfirmationEnabled = true;
        _v.WebApp.disableVerticalSwipes();
        _v.WebApp.BackButton.onClick(() => {
          router.go(-1);
        });
        setMiniAppHead();
        setMiniAppLink();
        resolve();
      });
    },
    //在线刷新
    onlineRefresh: (_) => {
      const time = 180 * 1000;
      const onlineRefreshFnc = async () => {
        try {
          await _v.$http.post("/user/online/refresh", {});
        } catch (err) {
          console.log("onlineRefresh err", err);
        }
        setTimeout(() => {
          onlineRefreshFnc();
        }, time);
      };
      setTimeout(() => {
        onlineRefreshFnc();
      }, time);
    },
    getCountryData: (_) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/system/country", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            const groupedData = {};

            data.forEach((item) => {
              const firstLetter = item.name[0].toUpperCase();
              if (!groupedData[firstLetter]) {
                groupedData[firstLetter] = [];
              }
              groupedData[firstLetter].push(item);
            });
            resolve(groupedData);
          },
          () => {
            resolve();
          }
        );
      });
    },
    updataUserData(_, params) {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/user/update", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },

    //获取好友排行
    geteRankingFriend: async () => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/ranking/friend", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data.list);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //获取用户排行
    getRankingPersonal: async () => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/ranking/personal", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            reject();
          }
        );
      });
    },
    //获取Spins余额
    getSpinsBalance: ({ state, commit, dispatch }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/lucky/spins/balance", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve(null);
              return;
            }
            state.balanceInfo.spins = res.data;

            dispatch("calcSpinsRecoveryTime");
            console.log("state.balanceInfo.spins", state.balanceInfo.spins);
            resolve(1);
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    //星星支付
    openInvoiceStarPay: async (_, params) => {
      return new Promise(async (resolve) => {
        const res = await _v.WebApp.openInvoice(params.url);
        async function invoiceClosedFnc(e) {
          _v.WebApp.offEvent("invoiceClosed", invoiceClosedFnc);
          console.log("ressssssss", res, e?.status);
          if (e?.status && e.status == "paid") {
            resolve(1);
          } else if (e?.status && e.status === "cancelled") {
            resolve();
          }
        }
        _v.WebApp.onEvent("invoiceClosed", invoiceClosedFnc);
      });
    },
    //购买星星
    paymentDepositStars: async (_, params) => {
      return new Promise(async (resolve) => {
        const res = await _v.$http.post("/payment/deposit", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //购买钻石
    paymentTicket: async (_, params) => {
      return new Promise(async (resolve) => {
        const res = await _v.$http.post("/payment/buydiamond", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    checkPaymentStars: ({ state, commit, dispatch, rootState }, params) => {
      return new Promise(async (resolve, reject) => {
        let paymentStarsInfo = state.paymentStarsInfo;
        paymentStarsInfo.isLoading = false;
        paymentStarsInfo.timer = null;
        const fnc = async (params, paymentStarsInfo) => {
          const res = await _v.$http.post("/payment/checkorder", params);
          console.log("res.coderes.coderes.coderes.code", res, res.code, params, paymentStarsInfo);
          if (res.code === 0) {
            clearTimeout(paymentStarsInfo.timer);
            paymentStarsInfo.timer = null;
            paymentStarsInfo.isLoading = false;
            paymentStarsInfo.paymentId = null;
            resolve(res.data);
          } else if (res.code === -2) {
            paymentStarsInfo.isLoading = true;
            paymentStarsInfo.timer = setTimeout(async () => {
              await fnc(params, paymentStarsInfo);
            }, 2000);
            // 还在等待用户支付完成
          } else {
            clearTimeout(paymentStarsInfo.timer);
            paymentStarsInfo.timer = null;
            paymentStarsInfo.isLoading = false;
            resolve(0);
            // 支付失败，提示错误信息
          }
        };
        fnc(params, paymentStarsInfo);
      });
    },
    //获取购买钻石价格列表
    getBuyTicketList: ({ state, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/system/diamondprice", {});
        vailcode(
          res,
          () => {
            const data = res.data.map((item) => {
              return {
                ...item,
                isLoading: false,
              };
            });
            if (!data) {
              resolve(null);
              return;
            }

            resolve(data);
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    //获取卡价格列表
    getCardPriceInfo: ({ state, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/system/cardprice", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve(null);
              return;
            }

            resolve(data);
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    //获取卡价格列表
    getCardPriceInfo: ({ state, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/system/cardprice", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve(null);
              return;
            }

            resolve(data);
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    getUserRights: ({ state, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/user/rights", {});
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve(null);
              return;
            }
            commit("setUserCardInfo", data);
            resolve(data);
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    buyCard: ({ state, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/payment/buycard", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve()
              return;
            }
            resolve(data);
          },
          () => {
            resolve()
          }
        );
      });
    },
    buyCardCredits: ({ state, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/user/credits", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve(null);
              return;
            }
            resolve(data);
          },
          () => {
            resolve(null);
          }
        );
      });
    },
  },
};
